<div class="section px-8 py-12 card flex flex-col gap-8 h-[90vh]">
  <div
    class="title text-5xl font-semibold w-full whitespace-nowrap line-clamp-1 text-ellipsis h-14 pb-2"
  >
    {{ project?.title }}
  </div>
  <div class="chart">
    <div class="card w-full grid grid-cols-3 px-7 py-14">
      <div
        class="chart-content relative w-fit content-center justify-self-center"
      >
        <p-chart
          type="doughnut"
          [data]="chartData"
          [options]="options"
          class="w-[15.5rem] h-[15.5rem]"
        />
        <div
          class="middle-text text-center absolute w-[15rem] h-[15rem] top-0 left-0 content-center"
        >
          @if (remainingDay == 0) {
            <div
              class="number-text font-bold text-3xl text-[#4A5565] text-wrap"
            >
              <span class="block">Due</span>
              <span class="block">today</span>
            </div>
          }
          @if (remainingDay < 0) {
            <div class="text text-2xl text-[#4A5565]">Over</div>

            <div class="number-text font-semibold text-5xl">
              {{ remainingDay * -1 }}
            </div>
            <div class="text text-2xl text-[#4A5565]">day(s)</div>
          } @else if (remainingDay > 0) {
            <div class="number-text font-semibold text-5xl">
              {{ remainingDay }}
            </div>
            <div class="text text-[1.25rem] text-[#4A5565]">day(s) left</div>
          }
        </div>
      </div>
      <div
        class="legend h-full flex flex-col gap-12 text-2xl justify-center col-span-2"
      >
        <div class="legend-item grid grid-cols-3 gap-6 items-center">
          <div class="legend-color flex flex-1 gap-6 items-center">
            <div
              class="box min-w-8 h-8 border border-[#D1D5DC] bg-[#D1D5DC] rounded-xl"
            ></div>
            <div class="title">Todo:</div>
          </div>
          <div class="value font-semibold">
            {{ progressData?.[0]?.total || 0 }}
          </div>
          <div class="value">
            {{
              progressData?.[0]?.percentage != "NaN"
                ? (progressData?.[0]?.percentage | number: "1.2-2")
                : "NaN"
            }}
            %
          </div>
        </div>
        <div class="legend-item grid grid-cols-3 gap-6 items-center">
          <div class="legend-color flex flex-1 gap-6 items-center">
            <div
              class="box min-w-8 h-8 border border-[#51A2FF] bg-[#51A2FF] rounded-xl"
            ></div>
            <div class="title">In progress:</div>
          </div>
          <div class="value font-semibold">
            {{ progressData?.[1]?.total || 0 }}
          </div>
          <div class="value">
            {{
              progressData?.[1]?.percentage != "NaN"
                ? (progressData?.[1]?.percentage | number: "1.2-2")
                : "NaN"
            }}
            %
          </div>
        </div>
        <div class="legend-item grid grid-cols-3 gap-6 items-center">
          <div class="legend-color flex flex-1 gap-6 items-center">
            <div
              class="box min-w-8 h-8 border border-[#00D492] bg-[#00D492] rounded-xl"
            ></div>
            <div class="title">Completed:</div>
          </div>
          <div class="value font-semibold">
            {{ progressData?.[2]?.total || 0 }}
          </div>
          <div class="value">
            {{
              progressData?.[2]?.percentage != "NaN"
                ? (progressData?.[2]?.percentage | number: "1.2-2")
                : "NaN"
            }}
            %
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="lead flex flex-col gap-7">
    <div class="title">
      <span class="font-semibold text-[2.5rem]">Project lead</span>
    </div>
    <div
      #wrapper
      class="lead-content bg-[#FFFFFFA3] rounded-full min-w-1/2 w-fit flex flex-row gap-6 px-2 py-3 pr-6 items-center !text-4xl"
    >
      <div
        class="avatar-content rounded-full min-w-[4.7rem] min-h-[4.7rem] text-center bg-blue-200 p-4"
      >
        <span class="avatar text-4xl font-semibold">{{
          avaLetter(projectLead.projectLeadName)
        }}</span>
      </div>
      @if (!isEditLead) {
        <div
          (click)="isEditLead = true"
          class="lead-name font-semibold text-3xl"
          [ngClass]="{
            'text-gray-400':
              projectLead.projectLeadName == '' || !projectLead.projectLeadName,
          }"
        >
          {{ projectLead.projectLeadName || "Enter a name for project lead" }}
        </div>
      } @else {
        <input
          class="!text-4xl"
          (blur)="isEditLead = false"
          type="text"
          pInputText
          [(ngModel)]="projectLead.projectLeadName"
          fluid
          [maxlength]="25"
          [minlength]="3"
          (input)="inputLead()"
          (keydown.enter)="isEditLead = false; updateProjectLead()"
        />
      }

      @if (!isEditTitle) {
        <div
          (click)="isEditTitle = true"
          class="lead-name font-semibold text-3xl"
          [ngClass]="{
            'text-gray-400':
              projectLead.projectLeadTitle == '' ||
              !projectLead.projectLeadTitle,
          }"
        >
          ({{
            projectLead.projectLeadTitle || "Enter a title for project lead"
          }})
        </div>
      } @else {
        (<input
          class="!text-4xl"
          (blur)="isEditTitle = false"
          type="text"
          pInputText
          [(ngModel)]="projectLead.projectLeadTitle"
          fluid
          [maxlength]="25"
          [minlength]="3"
          (input)="inputLead()"
          (keydown.enter)="isEditTitle = false; updateProjectLead()"
        />)
      }
    </div>
  </div>
  <div class="tasks flex flex-col gap-7">
    <div class="title">
      <span class="font-semibold text-[2.5rem]">Key tasks</span>
    </div>
    <div class="task-scroller">
      <div class="content flex flex-col gap-7" emcAutoScroll>
        <ng-container
          [ngTemplateOutlet]="task"
          [ngTemplateOutletContext]="{ $implicit: tasks ?? [] }"
        ></ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #task let-tasks>
  @if (tasks && tasks.length > 0) {
    @for (task of tasks; track task) {
      <div
        class="task card p-7 flex flex-col gap-4 min-h-[14.25rem] justify-between"
        [ngClass]="{
          '!min-h-[30rem]':
            task?.detailDescription?.description != null ||
            task?.detailChecklist ||
            task?.detail_description?.description != null ||
            task?.detail_checklist,
        }"
      >
        <div class="task-title font-semibold text-[1.750rem] line-clamp-2">
          {{ task?.title ?? "N/A" }}
        </div>

        @if (task?.detailDescription || task?.detail_description) {
          <div class="task-description text-3xl line-clamp-5">
            {{ (task?.detailDescription?.description || task?.detail_description?.description) ?? "N/A" }}
          </div>
        }

        @if (task?.detailChecklist || task?.detail_checklist) {
          @let checkList = task?.detailChecklist || task?.detail_checklist;
          <div class="task-checklists text-3xl flex flex-col gap-4">
            @for (
              checkItem of getSortedDetailChecklist(
                checkList.items
              ).slice(0, 3);
              track checkItem
            ) {
              <div class="checkitem flex gap-5">
                @let check =
                  checkItem.checked == false ? null : checkItem.checked;
                <p-radiobutton
                  [name]="checkItem?.title"
                  [ngModel]="check"
                  [value]="checkItem.checked"
                />
                <span class="name line-clamp-1">{{ checkItem?.title }}</span>
              </div>
            }

            @if (checkList.items?.length > 0) {
              @let doneItem =
                getCheckListProgress(checkList.items);
              <div
                class="bg-blue-200 h-15 w-fit px-4 py-2 items-center rounded-xl"
                [ngClass]="{
                  'bg-green-200':
                    doneItem == checkList.items.length,
                }"
              >
                <!-- <span class="text-blue-500 font-semibold"
                  >+{{ checkList.items?.length - 3 }} item{{
                    checkList.items?.length - 3 > 1 ? "s" : ""
                  }}</span
                > -->
                <span
                  class="text-blue-500 font-semibold"
                  [ngClass]="{
                    'text-green-500':
                      doneItem == checkList.items.length,
                  }"
                  >{{ doneItem }}/{{
                    checkList.items.length
                  }}
                  completed</span
                >
              </div>
            }
          </div>
        }

        <div class="more-info flex flex-row gap-4 items-center">
          @if (task.due_date ?? task.dueDate) {
            <div class="date-time">
              <div
                class="date-content flex flex-row gap-4 text-3xl items-center"
                [ngClass]="{
                  critical: task.priority == 'high',
                  warning: task.priority == 'warning',
                }"
              >
                <div class="date-icon">
                  <i class="pi pi-calendar !text-3xl"></i>
                </div>
                <div class="date">
                  {{ task.due_date ?? task.dueDate | date: "dd/MM/yyyy" }}
                </div>
              </div>
            </div>
          }

          @if (task?.assignees.length > 0) {
            <div
              class="vertical-devide border-l-[1px] border-[#101828] w-1 h-10"
            ></div>
            <div class="members flex flex-row items-center gap-6">
              <div class="member-avatar flex flex-row">
                @for (
                  profile of task.assignees.slice(0, 3);
                  track profile;
                  let i = $index
                ) {
                  <div
                    class="avatar p-2 bg-white w-fit h-fit rounded-full"
                    style="z-index: {{ task.assignees.length - i }}"
                  >
                    <div
                      class="avatar-content rounded-full w-[3.5rem] h-[3.5rem]"
                      style="background-image: url('{{
                        profile.profile_photo_url_base64
                      }}');"
                    ></div>
                  </div>
                }
              </div>
              <div class="member-name text-[1.8rem]">
                @for (
                  profile of task.assignees.slice(0, 3);
                  track profile;
                  let first = $first
                ) {
                  <span>{{ first ? "" : ", " }}</span
                  ><span class="name">{{
                    profile.display_name ?? profile.displayName
                  }}</span>
                }

                @if (task?.assignees?.length > 3) {
                  <span class="text-orange-700 font-semibold"
                    >, +{{ task?.assignees?.length - 3 }} other{{
                      task?.assignees?.length - 3 > 1 ? "s" : ""
                    }}</span
                  >
                }
              </div>
            </div>
          }
        </div>
      </div>
    }
  }
</ng-template>
